import React from 'react';
import SectionHeader from './SectionHeader';
import { SYNOPSIS } from '../mock';

export default function Synopsis() {
  return (
    <section id="synopsis" className="section-pad relative">
      {/* localized scrim to keep text readable on top of the moving holographic background */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 50% 50%, rgba(8,7,5,0.55) 0%, rgba(8,7,5,0.35) 60%, rgba(8,7,5,0.55) 100%)",
        }}
      />
      <div className="container-narrow relative">
        <SectionHeader chapter={SYNOPSIS.chapter} label={SYNOPSIS.label} heading={SYNOPSIS.heading} />
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7 space-y-6">
            <div
              className="p-6 md:p-8 rounded-sm"
              style={{
                background: "rgba(8,7,5,0.42)",
                backdropFilter: "blur(8px)",
                WebkitBackdropFilter: "blur(8px)",
                border: "1px solid rgba(200,161,74,0.10)",
              }}
            >
              {SYNOPSIS.paragraphs.map((p, i) => (
                <p key={i} className="font-serif text-[18px] md:text-[19px] leading-[1.75] text-[color:var(--bx-bone)]/95 [text-shadow:0_2px_18px_rgba(0,0,0,0.7)] mb-5 last:mb-0">
                  {p}
                </p>
              ))}
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="sticky top-24">
              <div
                className="p-8"
                style={{
                  background: "rgba(20,17,15,0.55)",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)",
                  border: "1px solid rgba(200,161,74,0.22)",
                }}
              >
                <div className="font-sc text-[10px] gold-text tracking-[0.42em] mb-6">PULLQUOTE</div>
                <p className="lead-quote font-serif text-2xl md:text-3xl italic [text-shadow:0_2px_18px_rgba(0,0,0,0.7)]">{SYNOPSIS.pullquote}</p>
                <div className="mt-8 grid grid-cols-2 gap-4 text-[11px] font-sc tracking-[0.32em]">
                  <div>
                    <div className="text-[color:var(--bx-muted)]">LANGUAGE</div>
                    <div className="gold-text mt-1">TAMIL</div>
                  </div>
                  <div>
                    <div className="text-[color:var(--bx-muted)]">GENRE</div>
                    <div className="gold-text mt-1">NOIR THRILLER</div>
                  </div>
                  <div>
                    <div className="text-[color:var(--bx-muted)]">FORMAT</div>
                    <div className="gold-text mt-1">2.39 : 1</div>
                  </div>
                  <div>
                    <div className="text-[color:var(--bx-muted)]">YEAR</div>
                    <div className="gold-text mt-1">2026</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
